import {IonButton, IonInput, IonItem, IonLabel, IonSpinner} from "@ionic/react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router";
import InputErrorMessage from "../../../components/InputErrorMessage";
import {createFileTemplate} from "../../../store/templateCreate/actions/createFileTemplate";
import {selectCreateFileTemplateStatus} from "../../../store/templateCreate/selectors/selectCreateFileTemplateStatus";
import { useMemo, useState } from 'react'
import {createArchive} from "../../../store/documentCreate/actions/createArchiveBasic";
import { useRef } from 'react'
import {selectSourceOrganizations} from "../../../store/users/selectors/selectSourceOrganizations";
import {selectUser} from "../../../store/userAuthentication/selectors/selectUser";

export const FileTemplateCreateForm: React.FC = () => {
  const createStatus = useSelector(selectCreateFileTemplateStatus);
  const history = useHistory();
  const dispatch = useDispatch();
  const fileInput = useRef<HTMLInputElement>(null)
  const [disableSubmit, setDisableSubmit] = useState<boolean>()
  const user = useSelector(selectUser);
  const sourceOrganization = user?.sourceOrganization;

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: {errors},
  } = useForm({
    defaultValues: {
      creationType: '',
      name: "",
      archive: null,
      archiveFilename: ''
    },
  });

  const onSubmit = async (data: { name: string; archive: any; archiveFilename: string }) => {
    try {
      // Opcional: validación rápida por si faltan datos del archivo
      if (!data.archive || !data.archiveFilename) {
        console.warn('Falta seleccionar el archivo PDF antes de crear la plantilla.');
        return;
      }
      if (!sourceOrganization) {
        console.warn('No se encontró la organización de origen (sourceOrganization) del usuario autenticado.');
        return;
      }

      const { payload }: any = await dispatch(
        createFileTemplate({
          name: data.name,
          archive: data.archive.id,
          sourceOrganization: sourceOrganization,
        })
      );

      return history.replace(`/app/tic/plantillas-file/detalle/${payload.id}`);
    } catch (error) {
      console.log(error);
    }
  };
  const onFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setDisableSubmit(true)
      try {
        const response = await dispatch<any>(createArchive(file))
        if (response?.payload) {
          setValue('archive', response.payload)
          setValue('archiveFilename', file.name)
        }
      } finally {
        setDisableSubmit(false)
      }
    }
  }

  const controllers = useMemo(() => {
    return [({ field: { onChange, value } }: any) => (
      <IonInput
        onIonChange={(e) => onChange(e.detail.value)}
        value={value}
        {...register("name", {
          required: "Campo obligatorio.",
        })}
      />
    )];
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <IonItem>
        <IonLabel position="stacked">Nombre de la plantilla de archivo</IonLabel>
        <Controller
          control={control}
          name="name"
          render={controllers[0]}
        />
      </IonItem>
      {errors.name && (
        <>
          <InputErrorMessage errorMessage={errors.name?.message || ""} paddingLeft={15}/> <br/>
        </>
      )}

      <IonItem lines="inset" onClick={() => fileInput?.current?.click()} disabled={disableSubmit} button>
        <IonLabel position="stacked">Archivo PDF</IonLabel>
        <Controller
          name="archiveFilename"
          control={control}
          render={({field: {value}}: any) => (
            <>
              <input ref={fileInput} type="file" accept="application/pdf" onChange={onFileChange} hidden/>
              <IonInput
                value={value}
                placeholder="Seleccionar archivo para asociar a esta plantilla"
                readonly
                {...register('archiveFilename', {
                  validate: () => {
                    const archivoNombre = watch('archiveFilename');
                    if (!archivoNombre) {
                      return 'Debe seleccionar un archivo PDF.';
                    }
                    return true;
                  }
                })}
              />
            </>
          )}
        />
      </IonItem>


      <IonButton type="submit" disabled={createStatus === "pending" || disableSubmit}>
        {createStatus === "pending" ? (
          <>
            <IonSpinner/> Creando plantilla...
          </>
        ) : (
          "Crear plantilla de archivo"
        )}
      </IonButton>
    </form>
  );
};
